import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import StageForm from './StageForm';
import { RT } from '../theme/retentionTheme';

// Small confirm dialog for the demo loop's two "no" paths: the tutor declines (a reason) and the parent rejects the
// demo (RemapDialog: reason from misc_masters + detail + updated preferences). Both unmap the tutor server-side.

export function DeclineDialog({ open, tutorName, busy, onClose, onConfirm }) {
  const [reason, setReason] = useState('');
  useEffect(() => {
    if (open) setReason('');
  }, [open]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Tutor declined</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: RT.muted, mb: 1.5 }}>
          Unmaps {tutorName || 'the tutor'} and reopens tutor mapping.
        </Typography>
        <TextField autoFocus fullWidth size="small" label="Reason" value={reason} onChange={(e) => setReason(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" disabled={!reason.trim() || busy} onClick={() => onConfirm(reason.trim())}>
          Unmap tutor
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const REMAP_CONFIG = (reasons) => ({
  sections: [
    {
      title: 'Why the parent said no',
      icon: 'solar:dislike-bold-duotone',
      fields: [
        { key: 'rejection_reason_id', label: 'Reason', type: 'chips', options: reasons },
        { key: 'rejection_detail', label: 'Detail', type: 'textarea' },
        { key: 'updated_preferences', label: 'Updated preferences', type: 'textarea' },
      ],
    },
  ],
});

export function RemapDialog({ open, tutorName, reasons = [], busy, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" gap={1}>
          <Icon icon="solar:refresh-circle-bold-duotone" width={24} color={RT.error} />
          Remap tutor
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: RT.muted, mb: 2 }}>
          Unmaps {tutorName || 'the tutor'}, closes this attempt and reopens tutor mapping.
        </Typography>
        <StageForm
          config={REMAP_CONFIG(reasons)}
          saving={busy}
          saveLabel="Unmap & remap"
          onSave={(changes) => onConfirm(changes)}
        />
      </DialogContent>
    </Dialog>
  );
}
